// libraryLaunch.js — Task 9 D-T9-g: the cross-page launch handoff (library page → agent shell).
//
// The library page and the agent shell are SEPARATE Rails page loads. To launch a catalog entry we
// stash a launch descriptor in sessionStorage, then navigate to /activity?mode=agent; the shell's
// mount-time effect consumes it (task → auto-sent chat turn; job → seeded NewAgentForm). Pure over a
// Storage-like object so it's node-testable and never throws (a malformed/absent value → null).

export const LIBRARY_LAUNCH_KEY = "vesta-library-launch"

// Write the descriptor. Returns true on success, false if storage is unavailable/throws.
export function stageLaunch(storage, descriptor) {
  if (!storage) return false
  try {
    storage.setItem(LIBRARY_LAUNCH_KEY, JSON.stringify(descriptor))
    return true
  } catch (_e) {
    return false
  }
}

// Read + REMOVE + parse the descriptor. Returns the descriptor, or null when absent/malformed. The
// REMOVE is unconditional-on-read so a back/forward navigation can never re-fire the launch.
export function consumeLaunch(storage) {
  if (!storage) return null
  let raw = null
  try {
    raw = storage.getItem(LIBRARY_LAUNCH_KEY)
    if (raw != null) storage.removeItem(LIBRARY_LAUNCH_KEY)
  } catch (_e) {
    return null
  }
  if (!raw) return null
  try {
    return JSON.parse(raw)
  } catch (_e) {
    return null
  }
}
